<template>
	<div class="sales-book-preview mx-auto">
		<div class="container-fluid">
			<h1 class="text-center mb-5">Obrazac KPO</h1>

			<p>PIB: {{company.taxNumber}}</p>
			<p>Obaveznik: {{company.owner}}</p>
			<p>Firma-radnje: {{company.name}}</p>
			<p>Sedište: {{company.address}}</p>
			<p>Šifra poreskog obveznika: {{company.registrationNumber}}</p>
			<p>Šifra delatnosti: {{company.classificationCode}}</p>

			<h2 class="text-center mb-5 mt-5">Knjiga o ostvarenom prometu paušalno oporezovanih obveznika</h2>

			<table class="table table-bordered mb-5">
				<thead>
					<tr class="text-center">
						<th scope="col" rowspan="2">Redni broj</th>
						<th scope="col" rowspan="2">Datum i opis knjiženja</th>
						<th scope="col" colspan="2" rowspan="1">Prihod od delatnosti</th>
						<th scope="col" rowspan="2">Svega prihodi od delatnosti</th>
					</tr>
					<tr class="text-center">
						<th scope="col">od prodaje proizvoda</th>
						<th scope="col">od izvršenih usluga</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="invoice in invoices">
						<th scope="row">{{invoice.number}}</th>
						<td>{{invoice.deliveryDate | date}} {{invoice.client.name}}</td>
						<td></td>
						<td class="text-right">{{invoice.total | decimal}}</td>
						<td class="text-right">{{invoice.total | decimal}}</td>
					</tr>
				</tbody>
			</table>

			<p>Sastavio: {{company.owner}}</p>
			<p>Odgovorno lice: {{company.owner}}</p>
		</div>
	</div>
</template>

<script>
import { invoiceStore } from '../stores/invoices';
import { settingStore } from '../stores/settings';
import moment from 'moment';

export default {
	name: 'sales-book-preview',

	data() {
		return {
			invoices: [],
			company: {}
		};
	},

	created() {
		this.init();
	},

	watch: {
		'$route'(to, from) {
			if (to.name === 'SalesBookPreview') {
				if (to.params.year)
					this.load(to.params.year);
			}
			else if (from.name === 'SalesBookPreview') {
				this.invoices = [];
				this.company = {};
			}
		}
	},

	methods: {
		init() {
			this.load(this.$route.params.year);
		},

		load(year) {
			this.invoices = invoiceStore.state.invoices.filter(i => i.type === 'invoice' && moment(i.deliveryDate.toDate()).year() === parseInt(year)).sort((i1, i2) => {
				return i1.number < i2.number ? -1 : ((i1.number > i2.number) ? 1 : 0);
			}) || [];

			this.company = settingStore.state.company;
		}
	}
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900&subset=latin-ext');

@page {
	margin: 0;
	size: A4;
}

.sales-book-preview {
	margin: 0;
	overflow: visible;
	position: relative;
 	box-sizing: border-box;
	page-break-after: always;
	width: 210mm;
	height: auto !important;
	font-family: 'Roboto', sans-serif;

	.table thead th {
		vertical-align: middle;
	}

	.container-fluid {
		padding-left: 20mm;
		padding-right: 20mm;
		padding-top: 10mm;
		padding-bottom: 10mm;
	}
}

@media screen {
	.sales-book-preview {
		background: white;
		box-shadow: 0 .5mm 2mm rgba(0,0,0,.3);
		margin: 5mm;
	}
}

@media print {
	body {
		margin: 0;
		padding: 0;
	}
	.sales-book-preview {
		width: 210mm;
	}
}
</style>



// WEBPACK FOOTER //
// SalesBookPreview.vue?513c79e1